var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"wave3d2"}})
}
var staticRenderFns = []

export { render, staticRenderFns }